// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vIcR","title":"Header_title__XzJWM","left":"Header_left__2DMMX","clinicName":"Header_clinicName__3wdsO"};